import { intervalTunables } from '../../../../../common/src/learn_rules.ts';
import { LearnAudioSession } from '../audio/learn_audio_session.ts';

// Interval Training's sounds (issues #3720, #3721). The page passes the note, chosen from the
// singer's range in common/src/interval_training.ts; this module only plays it.

// From a tap or a sound request to its first note, so the scheduled time is never already past:
// every sound Interval Training plays, the ladder's notes here and the session's runs on the page,
// and Sing in Solfège's sounds, which share this module's solo notes (issue #3722). The same 100 ms
// Pitch Match and the Range Finder lead their guides by; they keep their own, and importing one of
// theirs would tie this module to a page it has nothing to do with.
export const intervalSoundLeadMs = 100;

// A note played on its own on the piano: a rung of the Meet the syllables ladder now; a tapped
// syllable and the house button's do later (issue #3721). The tap is the user gesture, so the
// session is started here - start() resumes the context synchronously inside it, as Rhythm Echo's
// Start does - and no microphone is opened: nothing is listening to the singer yet. Resolves with
// the time the note really started, which is later than asked only after a slow soundfont load.
// The session plays one piano note at a time, so a second tap stops this note rather than
// sounding on top of it.
//
// `stillWanted` is asked once the session has started and before anything is scheduled; the page
// passes whether it is still mounted. A singer who leaves while the context is resuming has had
// the session put to rest by then, and a note scheduled on a resting context would wait on its
// stopped clock and sound when the next exercise starts it. Resolves with nothing in that case.
export async function playSoloNote(
  audio: LearnAudioSession,
  midi: number,
  stillWanted: () => boolean = () => true,
): Promise<number | undefined> {
  await audio.start();
  if (!stillWanted()) {
    return undefined;
  }
  return audio.schedulePianoNote(midi, audio.nowMs() + intervalSoundLeadMs, intervalTunables.soloNoteMs);
}
